<template>
  <aside class="instructions-bar">
    <b-container fluid>
      <b-row align-v="center">
        <b-col>
          <router-link to="/"
            ><img
              class="logo"
              height="35"
              src="https://faker.agency/sendcloud/images/sendcloud-logo.svg"
          /></router-link>
        </b-col>
        <b-col align-h="end">
          Paste this embed code into your web page, blog or CMS:
          <code class="embed-code">{{ embed }}</code>
        </b-col>
      </b-row>
    </b-container>
  </aside>
</template>

<script>
import { BCol, BContainer, BRow } from "bootstrap-vue";

export default {
  name: "InstructionsBar",
  components: {
    BContainer,
    BRow,
    BCol,
  },
  computed: {
    embed() {
      return `<iframe src="https://marketing.sendcloud.com/#/embed/${this.$route.name}?lang=en" style="height: 800px; width: 100%;"></iframe>`;
    },
  },
};
</script>

<style lang="postcss">
.instructions-bar {
  z-index: 2;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  background: white;
  width: 100%;
  padding: 25px;
  text-align: right;
  box-shadow: 0px -3px 5px rgba(0, 0, 0, 0.08);
  @media screen and (max-width: 567px) {
    text-align: left;
  }
}

.logo {
  display: block;
  @media screen and (max-width: 567px) {
    margin-bottom: 20px;
  }
}

.embed-code {
  padding: 5px 10px;
  margin-top: 5px;
  display: inline-block;
  background: #f4f4f4;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  user-select: text;
}
</style>
